import { useEffect, useState, useContext } from "react";
import { api } from "../App";
import Card from "./card";
import Loading from "./loading";

const Performances = () => {
  const { apiData } = useContext(api);

  const [performances, setPerformances] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    const data = apiData.filter(
      (obj) =>
        obj.category_id === 360 ||
        obj.tags?.some((obj) => obj.name === "performances")
    );
    setPerformances(data);
  }, [apiData]);

  useEffect(() => {
    if (performances.length) {
      setLoading(false);
    }
  }, [performances]);

  return loading ? (
    <Loading />
  ) : (
    <div className="api-data">
      {!!performances.length ? (
        performances.map((obj) => <Card obj={obj} key={obj.id} />)
      ) : (
        <p className="nothing">There is nothing coming up at this time.</p>
      )}
    </div>
  );
};

export default Performances;
